import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

export function initializeKeycloak(keycloak: KeycloakService) {

   return () => {

      return new Promise<void>(async (resolve, reject) => {

         try {

            await keycloak.init({

               config: {
                  url: environment.KeycloakConfig.url,
                  realm: environment.KeycloakConfig.realm,
                  clientId: environment.KeycloakConfig.clientId,
               },
               enableBearerInterceptor: true,
               bearerPrefix: 'Bearer',
               initOptions: {
                  onLoad: 'check-sso'
               }
            })
            const keycloakAuth = keycloak.getKeycloakInstance();
            localStorage.setItem('token', keycloakAuth.token)

            const updateToken = async (): Promise<string> => {
               try {
                  const success = keycloakAuth.updateToken(5);
                  return new Promise((resolve, reject) => {
                     keycloakAuth.updateToken(5).then
                     if (success) {
                        resolve(keycloakAuth.token);
                     } else {
                        reject();
                     }
                  });
               } catch (error) {
                  console.error('Error during token update:', error);
                  throw error;
               }
            };

            const login = async (): Promise<void> => {
               try {
                  this.appService.logEvent('LOGOUT');
                  const success = this.keycloakAuthService.login();
                  return new Promise<void>((resolve, reject) => {
                     if (success) {
                        resolve();
                     } else {
                        reject();
                     }
                  });
               } catch (error) {
                  console.error('Error during login:', error);
                  throw error;
               }
            }

            keycloakAuth.onTokenExpired = () => {
               if (keycloakAuth.refreshToken) {
                  updateToken();
               } else {
                  login();
               }
            };
            resolve();



         } catch (error) {

            reject(error);

         }

      });

   };

}
